import * as yup from 'yup'
import { useState } from 'react'
import {
  Alert,
  Dialog,
  IconButton,
  Typography,
  MenuItem,
  Button
} from '@mui/material'
import RowStack from 'components/atoms/container/RowStack'
import InCardStack from 'components/atoms/container/InCardStack'
import colors from 'styles/colors'
import { getFullName, desctructUser } from 'utils/formatText'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import { validationsRules } from 'utils/formValidations'
import { patchRequest } from 'utils/api'
import {
  USER_CONNECTION_RELATIONSHIP,
  USER_CONNECTION_URL
} from 'services/constants'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import FormSelectInput from 'components/atoms/input/FormSelectInput'
import OverlayLoading from 'components/atoms/OverlayLoading'

const EditConnectionType = ({
  connection,
  initialRelationship,
  setRelationship
}) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [firstName, , email] = desctructUser(connection?.user)
  const [loading, setLoading] = useState(false)
  const [updateError, setUpdateError] = useState(false)
  const typoSx = {
    color: colors.Grey400,
    wordBreak: 'break-all'
  }

  const formik = useFormik({
    initialValues: {
      relationship: initialRelationship
    },
    validationSchema: yup.object({
      relationship: validationsRules.textRequired
    }),
    onSubmit: async values => {
      setLoading(true)
      const requestBody = {
        relationship: values.relationship
      }
      const res = await patchRequest(
        `${USER_CONNECTION_URL}/${connection.id}`,
        requestBody
      )
      if (res.status === 200) {
        setUpdateError(false)
        setOpen(false)
        setRelationship(values.relationship)
        setLoading(false)
      } else {
        setUpdateError(true)
        setLoading(false)
      }
    }
  })

  const handleDialogOpen = () => {
    formik.setFieldValue('relationship', initialRelationship)
    setOpen(true)
  }

  return (
    <>
      <IconButton onClick={handleDialogOpen}>
        <EditOutlinedIcon />
      </IconButton>

      <Dialog
        onClose={() => setOpen(false)}
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            width: 356,
            padding: 8,
            borderRadius: 3
          }
        }}>
        <InCardStack spacing={8} alignItems={'flex-start'}>
          <Typography variant='h4' sx={typoSx}>
            {getFullName(connection.user)}
          </Typography>

          <Typography variant='body1' sx={typoSx}>
            {t('contact.updateContactType', {
              name: firstName || email
            })}
          </Typography>

          <FormSelectInput
            fullWidth
            type='text'
            name='relationship'
            formik={formik}
            placeholder={t('myTeam.selectRelationship')}
            variant='standard'
            attributeName='relationship'>
            {USER_CONNECTION_RELATIONSHIP.map(item => (
              <MenuItem key={item.value} value={item.value}>
                {t(`constants.userConnRelationship.${item.value}`)}
              </MenuItem>
            ))}
          </FormSelectInput>
          {updateError ? (
            <Alert severity='error'>{t('contact.failedToUpdateContact')}</Alert>
          ) : null}

          <RowStack spacing={4} justifyContent={'flex-end'}>
            <Button
              color='muted'
              onClick={() => setOpen(false)}>
              {t('common.cancel')}
            </Button>

            <Button
              disabled={initialRelationship === formik.values['relationship']}
              onClick={() => formik.handleSubmit()}>
              {t('contact.update')}
            </Button>
          </RowStack>
        </InCardStack>
      </Dialog>
      <OverlayLoading open={loading} />
    </>
  )
}

export default EditConnectionType
